import { render, staticRenderFns } from "./IfCanTakePart.vue?vue&type=template&id=59a07bad&scoped=true"
import script from "./IfCanTakePart.vue?vue&type=script&lang=js"
export * from "./IfCanTakePart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a07bad",
  null
  
)

export default component.exports